"use client";

import { useEffect } from "react";

/**
 * Registers /sw.js on mount. Must be a client component because
 * `navigator.serviceWorker` doesn't exist on the server.
 *
 * Only runs in production - in dev, HMR + the service worker fight
 * over cache control and you get stale bundles that persist across
 * `next dev` restarts. Easier to leave SW out of dev entirely. To
 * test the install flow locally, run `npm run build && npm start` and
 * expose via ngrok/cloudflared - `localhost` itself is a secure
 * context, so SW also works there without a tunnel.
 */
export default function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    // Register with a stable scope so navigations anywhere on the
    // origin are covered. Failures are swallowed - a missing SW just
    // means no install prompt, not a broken app.
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // intentionally silent
    });
  }, []);

  return null;
}
